//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import { mapState } from 'vuex'
	import { userOpenMany, api_SellItem } from '@/api'
	export default{
		name:'operation',
		props:{
			status:{
				type:Number,
				default:0
			},
			animation_status:{
				type:Number,
				default:0
			},
			rootGold:{
				type:Boolean,
				default:false
			},
			box_name:{
				type:String
			},
			price:{}
		},
		data(){
			return{
				prize:{}
			}
		},
		computed:{
			...mapState(['user'])
		},		
		methods:{
			/*正常状态*/
			//返回
			routeReturn(){
				this.$router.go(-1)
			},
			
			//开箱
			open(){
				if(!this.user.nickname)
					return this.$store.commit('set_logpopShow', true);

				this.set_official_loading(true)
				const openParams = { id: this.$route.query.id, count: 1 };
				if (this.$route.query.uhc) openParams.useHappyCoin = true;
				userOpenMany(openParams).then(res => {
					if (res.data.code === 0) {
						this.prize = res.data.data[0]
						this.$emit('open_success',this.prize)
						this.set_official_loading(false)
						//this.get_user()
					} else {
						this.set_official_loading(false)
						this.$toast.error(res.data.msg);
					}
				}).catch( err => this.set_official_loading(false))				
			},
			
			
			/*开启中*/
			//终止开箱
			suspend(){

				console.log('记录2');
				if(sessionStorage.getItem('renew')){
					let list = JSON.parse(sessionStorage.getItem('renew'))
					list.unshift(this.prize.mSerial)
					sessionStorage.setItem('renew',JSON.stringify(list))
				}else{
					let list = [this.prize.mSerial]
					sessionStorage.setItem('renew',JSON.stringify(list))
				}

				console.log(sessionStorage.getItem('renew'));
				this.set_scrape()
				this.$emit('suspend')
			},
			
			
			
			/*结果显示*/
			// 兑换
			sell(){
				this.set_official_loading(true)
				let data = [this.prize.mSerial]
				api_SellItem({
					lstmSerial: data
				}).then(res => {
					if (res.data.code===0) {
						this.$toast.success( res.data.msg)
						this.close()
						this.set_official_loading(false)
					} else {
						this.set_official_loading(false)
						this.$toast.error( res.data.msg)
					}
				}).catch( err => this.set_official_loading(false))
			},
			
			//放入库存
			close(){
				this.$emit('to_stock')
			},
			
			//跳转
			to_route(path){
				this.$router.push(path)
			}
		}
	}
